import { background, color, position, transform } from "@chakra-ui/react";

export default {
    parts: [
        'largeTypo',
        'xsTypo',
        'title',
        'fieldContainer',
        'submitButton',
        'disclaimerText',
        'downloadAppContainer',
        'downloadAppContent',
        'downloadAppTitle',
        'downloadAppSubTitle',
        'downloadAppPoints',
        'downloadAppLogo',
        'downloadPlayLogo',
        'smsContentBox',
        'smsHeader',
        'smsTitle',
        'smsCloseButton',
        'smsSubtitle',
        'smsButton',
        'smsDisclaimer',
        'smsImageBox',
        'smsImage',
        'smsModalContent',
        'smsModalBody'
    ],
    baseStyle: {
        largeTypo: {
            color: 'webTypo.textPrimary',
            display: {base: 'block'},
            textStyle: 'webH3',
            textTransform: {base: 'uppercase'},
            letterSpacing: {base: 0}
        },
        xsTypo: {
            color: 'webTypo.textPrimary',
            display: {base: 'block'},
            textStyle: 'bodySmRegular'
        },
        title: {
            marginBottom: {base: 4}
        },
        preferenceLabel: {
            marginBottom: {base: 3},
            textStyle: 'bodySmRegular'
        },
        fieldContainer: {
            position: 'relative'
        },
        inputStyling: {
            textStyle: 'bodySmRegular'
        },
        submitButton: {
            color: 'webTypo.textPrimary',
            display: {base: 'block'},
            letterSpacing: {base: 0},
            textStyle: {base: 'bodySmRegular', lg: 'bodySmRegular'},
            position: 'absolute',
            top: '14px',
            right: 0,
        },
        disclaimerText: {
            color: 'webTypo.textSecondary',
            textStyle: 'bodyXsRegular',
            marginTop: {base: 3}
        },
        methodRadioRow: {
            display: 'flex',
            flexWrap: 'no-wrap',
            gap: 5,
            marginBottom: {base: 6}
        },
        downloadAppContainer: {
            padding: {base: 4},
            backgroundColor: {base: 'webTheme.backgroundPrimaryBrand'},
            display: {base: 'grid', lg: 'flex'},
            justifyContent: {base: 'none', lg: 'space-between'}
        },
        downloadAppContent: {
            maxWidth: {base: '100%', lg: 'calc(100% - 16px)'},
            justifyContent: {base: 'none', lg: 'center'},
            paddingRight: {base: 0, lg: 4}
        },
        downloadAppTitle: {
            textStyle: 'webH3',
            marginBottom: {base: 5}
        },
        downloadAppSubTitle: {
            textStyle: 'bodySmRegular',
            marginBottom: {base: 5, lg: 4}
        },
        downloadAppStores: {
            justifyContent: {base: 'space-between', lg: 'start'}
        },
        downloadAppPoints: {
            textStyle: 'bodySmRegular',
            fontWeight: 'bold',
            padding: '0 4px'
        },
        downloadAppLogo: {
            width: {base: '120px'},
            height: {base: '40px'}
        },
        downloadPlayLogo: {
            width: {base: '135px'},
            height: {base: '40px'}
        },
        logoQR: {
            width: {base: '76px'},
            height: {base: '76px'}
        },
        fieldError: {
            color: {base: 'red.600'},
            fontSize: {base: 'sm'},
            marginTop: {base: 2}
        },
        checkMarkIcon: {
            width: {base: '20px'},
            height: {base: '20px'},
            marginRight: {base: 1}
        },
        confirmationMessage: {
            alignItems: {base: 'start'},
            fontSize: {base: 'xs'},
            marginTop: {base: 6},
            marginBottom: {base: 6, lg: '86px'},
            textTransform: {base: 'uppercase'},
            fontWeight: {base: 'bold'}
        },
        smsContentBox: {
            flex: 1,
            padding: 4
        },
        smsHeader: {
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 8
        },
        smsTitle: {
            flex: 1
        },
        smsCloseButton: {
            flexShrink: 0,
            minW: 'auto',
            w: 'auto',
            h: 'auto'
        },
        smsSubtitle: {
            marginBottom: 6
        },
        smsButton: {
            width: '100%',
            marginTop: 2
        },
        smsDisclaimer: {
            color: 'webTypo.textSecondary',
            marginTop: 6
        },
        smsImageBox: {
            flex: 1,
            minHeight: '100%'
        },
        smsImage: {
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            display: 'block'
        },
        smsModalContent: {
            maxWidth: '800px',
            overflow: 'hidden',
            borderRadius: 0
        },
        smsModalBody: {
            padding: 0
        }
    }
}
